import { TOption } from 'components/OWForm/OWSelect'
import { UOMContract } from 'models'
import { ReactNode, createContext, useContext } from 'react'
import { Dictionary } from 'utilities/typeUtility/typeUtility'

export interface INewUOMContext {
    uom: UOMContract
    uoms: UOMContract[]
    uomClasseOptions: TOption[]
    duplicatedUOMNames: string[]
    duplcatedUOMSymbols: Dictionary<string[]>
    submitting: boolean
    onSubmit: (contract: UOMContract) => Promise<void>
}

const NewUOMContext = createContext({} as INewUOMContext)

type NewUOMContextProviderProps = INewUOMContext & { children: ReactNode }

function NewUOMContextProvider({
    children,
    ...props
}: NewUOMContextProviderProps) {
    return (
        <NewUOMContext.Provider value={{ ...props }}>
            {children}
        </NewUOMContext.Provider>
    )
}

export default NewUOMContextProvider

export const useNewUOMContext = () => useContext(NewUOMContext)
